import { render, staticRenderFns } from "./RecentTreatmentWarningModal.vue?vue&type=template&id=1aa2ba8e"
import script from "./RecentTreatmentWarningModal.vue?vue&type=script&lang=js"
export * from "./RecentTreatmentWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports